import { Box, IconButton } from '@mui/material'
import React from 'react'
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedStations } from 'app/containers/Games/redux/selector';
import { actions } from 'app/containers/Games/redux/slice';

export default function DirectionKeys({
    backgroundColor,
    disabled,
    index,
    value
}:{
    backgroundColor?: string
    disabled?: boolean
    index: number;
    value?: number;
}) {
    const selectedStations = useSelector(selectSelectedStations);
    const isUpDisabled = index === 0;
    const isDownDisabled = index === selectedStations.length - 1;
    const dispatch = useDispatch();

    const handleMoveUp = () => {
        if (index > 0) {
            const newSelectedQuestions = [...selectedStations];
            const temp = newSelectedQuestions[index];
            newSelectedQuestions[index] = newSelectedQuestions[index - 1];
            newSelectedQuestions[index - 1] = temp;
            dispatch(actions.setSelectedStations(newSelectedQuestions));
        }
    };

    const handleMoveDown = () => {
        if (index < selectedStations.length - 1) {
            const newSelectedQuestions = [...selectedStations];
            const temp = newSelectedQuestions[index];
            newSelectedQuestions[index] = newSelectedQuestions[index + 1];
            newSelectedQuestions[index + 1] = temp;
            dispatch(actions.setSelectedStations(newSelectedQuestions));
        }
    };

    return (
        <Box
            sx={{
                width: "60px",
                display: "flex",
                alignItems: "center",
                gap: "6px"
            }}
        >
            <IconButton 
                disabled={disabled || isUpDisabled}
                sx={{
                    width: "20px",
                    height: "20px",
                    padding: "0px",
                    backgroundColor: backgroundColor ?? "#ffffff",
                    "&:disabled": {
                        backgroundColor: backgroundColor ?? "#ffffff",
                    }
                }}
                onClick={handleMoveUp}
            >
                <ArrowUpwardIcon 
                    sx={{
                        fontSize: "14px",
                        color: disabled ? "#D7D7E0" : "#5E6781"
                    }}
                />
            </IconButton>
            <IconButton 
                sx={{
                    width: "20px",
                    height: "20px",
                    padding: "0px",
                    backgroundColor: backgroundColor ?? "#ffffff",
                    "&:disabled": {
                        backgroundColor: backgroundColor ?? "#ffffff",
                    }
                }}
                disabled={disabled || isDownDisabled}
                onClick={handleMoveDown}
            >
                <ArrowDownwardIcon 
                    sx={{
                        fontSize: "14px",
                        color: disabled ? "#D7D7E0" : "#5E6781"
                    }}
                />
            </IconButton>
        </Box>
    )
}
